import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getHomepageUrl } from '../utils/constants';

/**
 * Legacy storefront paths moved to the separate website app (website/).
 * Forward them there, keeping path and query intact.
 */
export default function ExternalRedirect() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const base = getHomepageUrl().replace(/\/+$/, '');
    window.location.replace(`${base}${pathname}${search}`);
  }, [pathname, search]);

  return null;
}
